<template>
  <oxd-input-field type="select" :options="options" />
</template>

<script>
import {ref, watch} from 'vue';
import {APIService} from '@ohrm/core/util/services/api.service';

export default {
  name: 'JobRoleDropdown',
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const options = ref([]);
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/admin/job-role',
    );

    const loadJobRoles = () => {
      http.getAll({limit: 0, ...props.params}).then(({data}) => {
        // If no meta.details, load only job roles
        options.value = data.data.map((item) => ({
          id: item.id,
          label: item.name,
          headCount: item.headCount,
        }));
      });
    };

    // Watch for changes in the projectId and reload the job roles
    watch(
      () => props.params.projectId,
      () => {
        loadJobRoles();
      },
      {immediate: true}, // Run immediately on mount
    );

    return {
      options,
    };
  },
};
</script>
